import { defineSemanticTokens, defineTokens } from '@pandacss/dev'

const tokens = defineTokens.colors({
  light: {
    '1': { value: '#fdfcfc' },
    '2': { value: '#fdf7f5' },
    '3': { value: '#f6edea' },
    '4': { value: '#efe4df' },
    '5': { value: '#e7d9d3' },
    '6': { value: '#dfcdc5' },
    '7': { value: '#d3bcb3' },
    '8': { value: '#c2a499' },
    '9': { value: '#a18072' },
    '10': { value: '#957468' },
    '11': { value: '#7d5e54' },
    '12': { value: '#43302b' },
    a1: { value: '#55000003' },
    a2: { value: '#cc33000a' },
    a3: { value: '#92250015' },
    a4: { value: '#80280020' },
    a5: { value: '#7423002c' },
    a6: { value: '#7324003a' },
    a7: { value: '#6c1f004c' },
    a8: { value: '#671c0066' },
    a9: { value: '#551a008d' },
    a10: { value: '#4c150097' },
    a11: { value: '#3d0f00ab' },
    a12: { value: '#1d0600d4' },
  },
  dark: {
    '1': { value: '#141110' },
    '2': { value: '#1c1917' },
    '3': { value: '#262220' },
    '4': { value: '#302a27' },
    '5': { value: '#3b3330' },
    '6': { value: '#493e3a' },
    '7': { value: '#5a4c47' },
    '8': { value: '#6f5f58' },
    '9': { value: '#a18072' },
    '10': { value: '#ae8c7e' },
    '11': { value: '#d4b3a5' },
    '12': { value: '#ede0d9' },
    a1: { value: '#d1110004' },
    a2: { value: '#fbbc910c' },
    a3: { value: '#faceb817' },
    a4: { value: '#facdb622' },
    a5: { value: '#ffd2c12d' },
    a6: { value: '#ffd1c03c' },
    a7: { value: '#fdd0c04f' },
    a8: { value: '#ffd6c565' },
    a9: { value: '#fec7b09b' },
    a10: { value: '#fecab5a9' },
    a11: { value: '#ffd7c6d1' },
    a12: { value: '#fff1e9ec' },
  },
})
const semanticTokens = defineSemanticTokens.colors({
  '1': { value: { _light: '{colors.bronze.light.1}', _dark: '{colors.bronze.dark.1}' } },
  '2': { value: { _light: '{colors.bronze.light.2}', _dark: '{colors.bronze.dark.2}' } },
  '3': { value: { _light: '{colors.bronze.light.3}', _dark: '{colors.bronze.dark.3}' } },
  '4': { value: { _light: '{colors.bronze.light.4}', _dark: '{colors.bronze.dark.4}' } },
  '5': { value: { _light: '{colors.bronze.light.5}', _dark: '{colors.bronze.dark.5}' } },
  '6': { value: { _light: '{colors.bronze.light.6}', _dark: '{colors.bronze.dark.6}' } },
  '7': { value: { _light: '{colors.bronze.light.7}', _dark: '{colors.bronze.dark.7}' } },
  '8': { value: { _light: '{colors.bronze.light.8}', _dark: '{colors.bronze.dark.8}' } },
  '9': { value: { _light: '{colors.bronze.light.9}', _dark: '{colors.bronze.dark.9}' } },
  '10': { value: { _light: '{colors.bronze.light.10}', _dark: '{colors.bronze.dark.10}' } },
  '11': { value: { _light: '{colors.bronze.light.11}', _dark: '{colors.bronze.dark.11}' } },
  '12': { value: { _light: '{colors.bronze.light.12}', _dark: '{colors.bronze.dark.12}' } },
  a1: { value: { _light: '{colors.bronze.light.a1}', _dark: '{colors.bronze.dark.a1}' } },
  a2: { value: { _light: '{colors.bronze.light.a2}', _dark: '{colors.bronze.dark.a2}' } },
  a3: { value: { _light: '{colors.bronze.light.a3}', _dark: '{colors.bronze.dark.a3}' } },
  a4: { value: { _light: '{colors.bronze.light.a4}', _dark: '{colors.bronze.dark.a4}' } },
  a5: { value: { _light: '{colors.bronze.light.a5}', _dark: '{colors.bronze.dark.a5}' } },
  a6: { value: { _light: '{colors.bronze.light.a6}', _dark: '{colors.bronze.dark.a6}' } },
  a7: { value: { _light: '{colors.bronze.light.a7}', _dark: '{colors.bronze.dark.a7}' } },
  a8: { value: { _light: '{colors.bronze.light.a8}', _dark: '{colors.bronze.dark.a8}' } },
  a9: { value: { _light: '{colors.bronze.light.a9}', _dark: '{colors.bronze.dark.a9}' } },
  a10: { value: { _light: '{colors.bronze.light.a10}', _dark: '{colors.bronze.dark.a10}' } },
  a11: { value: { _light: '{colors.bronze.light.a11}', _dark: '{colors.bronze.dark.a11}' } },
  a12: { value: { _light: '{colors.bronze.light.a12}', _dark: '{colors.bronze.dark.a12}' } },
  default: { value: { _light: '{colors.bronze.light.9}', _dark: '{colors.bronze.dark.9}' } },
  emphasized: { value: { _light: '{colors.bronze.light.10}', _dark: '{colors.bronze.dark.10}' } },
  fg: { value: { _light: 'white', _dark: 'white' } },
  text: { value: { _light: '{colors.bronze.light.a11}', _dark: '{colors.bronze.dark.a11}' } },
})

export default {
  name: 'bronze',
  tokens,
  semanticTokens,
}
